import { render, staticRenderFns } from "./TemplateListItem.vue?vue&type=template&id=08d7c894"
import script from "./TemplateListItem.vue?vue&type=script&lang=ts"
export * from "./TemplateListItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports